// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSaveTaskDefaultResponse {
    static getAttributeTypeMap() {
        return AccountSaveTaskDefaultResponse.attributeTypeMap;
    }
}
AccountSaveTaskDefaultResponse.discriminator = undefined;
AccountSaveTaskDefaultResponse.additionalProperties = false;
AccountSaveTaskDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
];
//# sourceMappingURL=accountSaveTaskDefaultResponse.js.map